//Adding by: Samah
//date: 04/Aug/2022
//description: This File Handel Listing CreditNotes Data
import React from "react";
import {Page} from "components/common";
import {compose} from "recompose";
import {Nav, TabContent} from "reactstrap";
import Table from "./RepeatingTable";
import {Trans} from "react-i18next";
import {Switch} from "react-router-dom";

const accPayCheck = /purchases|payable|accounts_payable/

const getTable = (Statuses) => (props) =>
  (
    <Table
      filters={{
        extra_params: {
          Statuses,
          Type: props.payable ? "ACCPAY" : "ACCREC",
        },
        raw: `(${Statuses.split(",")
          .map((i) => `Status="${i}"`)
          .join(" OR ")}) AND ${
            props.location.pathname.match(accPayCheck) ? 'TYPE="ACCPAY"' : 'TYPE="ACCREC"'
        }`,
      }}
      status={Statuses}
      {...props}
    />
  );

const All = getTable("DRAFT,AUTHORISED");
const Draft = getTable("DRAFT");
const Approved = getTable("AUTHORISED");

export const ListCreditNotes = ({match, allowCreate=true}) => {
  const [all, setAll] = React.useState(false)
  const [draft, setDraft] = React.useState(false)
  const [approved, setApproved] = React.useState(false)

  const currentUrl = window.location.href;
  const isPayable = accPayCheck.test(currentUrl);

  const typeR = isPayable ? 'Bill' : 'Invoice';

  const recpay = isPayable
  ? 'https://go.xero.com/RepeatTransactions/Edit.aspx?type=AP'
  : '/accounts_receivable/repeating/edit/new';

  const isExternalLink = recpay.startsWith('http');


  const gotToAll = () => {
    setAll(true)
    setDraft(false)
    setApproved(false)
  }
  const gotToDraft = () => {
    setAll(false)
    setDraft(true)
    setApproved(false)
  }
  const gotToApproved = () => {
    setAll(false)
    setDraft(false)
    setApproved(true)
  }

  return (
    <Page className="inv-tabs nw-list">
      <div>
        <div>
          {allowCreate &&(<a href={recpay} target={isExternalLink ? '_blank' : '_self'} rel={isExternalLink ? 'noopener noreferrer' : undefined} className="btn btn-primary ml-0">
            <Trans>New Repeating {typeR}</Trans>
            <span className="mx-1"/>
            <span className="fa fa-plus"/>
          </a>)}
          {typeR === "Bill" && (
            <p className="text-muted"><Trans>Note: Repeating Bills can only be created on Xero. You will be redirected upon clicking above button.</Trans></p>
          )}
        </div>
        <Nav tabs className="nw-tabs2 cursor-pointer my-3">
          <div onClick={gotToAll} className={all == true ? `active-tabNum`: ``} ><Trans>All</Trans></div>
          <div onClick={gotToDraft} className={draft == true ? `active-tabNum`: ``}  ><Trans>Draft</Trans></div>
          <div onClick={gotToApproved} className={approved == true ? `active-tabNum`: ``}><Trans>Authorised</Trans></div>
        </Nav>
        <TabContent>
          <Switch>
            {all == true ? <All /> : null}
            {draft == true ? <Draft /> : null}
            {approved == true ? <Approved /> : null}
            <All />
          </Switch>
        </TabContent>
      </div>
    </Page>
  )
};

export const enhance = compose();
export default enhance(ListCreditNotes);
